export default __webpack_public_path__ + "static/media/card2400.db5c7d68.jpg";